import { useEffect } from 'react';

interface ThemeProviderProps {
  children: React.ReactNode;
}

export const ThemeProvider = ({ children }: ThemeProviderProps) => {
  useEffect(() => {
    // Force dark theme by ensuring the 'dark' class is always on the HTML element
    document.documentElement.classList.add('dark');
    document.body.style.backgroundColor = 'hsl(var(--background))';
    document.body.style.color = 'hsl(var(--foreground))';
    
    // Override any potential light mode settings
    const meta = document.querySelector('meta[name="color-scheme"]');
    if (meta) {
      meta.setAttribute('content', 'dark');
    } else {
      const newMeta = document.createElement('meta');
      newMeta.name = 'color-scheme';
      newMeta.content = 'dark';
      document.head.appendChild(newMeta);
    }
  }, []);

  return <>{children}</>;
};